import { render, staticRenderFns } from "./goods-sales.vue?vue&type=template&id=4a5c7ee3&scoped=true&"
import script from "./goods-sales.vue?vue&type=script&lang=js&"
export * from "./goods-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c7ee3",
  null
  
)

export default component.exports